"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TLRUCache = void 0;
const lru_cache_1 = require("./lru-cache");
/**
 * Time-aware, least-recently-used cache (TLRU). Variant of LRU where entries have valid lifetime.
 * @param {number} maxSize - Maximum cache size
 * @param {number} ttl - Time in milliseconds after which cache entry will evict itself
 * @param {number} evictionInterval - Frequency of cache entries eviction check
 **/
class TLRUCache extends lru_cache_1.LRUCache {
    constructor(maxSize, ttl) {
        super(maxSize);
        this.maxSize = maxSize;
        this.ttl = ttl;
        this.cacheEntriesTTLRegistry = new Map();
    }
    getCacheEntryEvictionTime() {
        return new Date(Date.now() + this.ttl);
    }
    clearCacheEntryEvictionTimeIfExists(key) {
        if (this.cacheEntriesTTLRegistry.has(key)) {
            this.cacheEntriesTTLRegistry.delete(key);
        }
    }
    isCacheEntryValid(key) {
        const now = new Date(Date.now());
        const evictionDate = this.cacheEntriesTTLRegistry.get(key);
        return evictionDate !== undefined ? now < evictionDate : false;
    }
    setCacheEntryEvictionTime(key) {
        this.cacheEntriesTTLRegistry.set(key, this.getCacheEntryEvictionTime());
    }
    resetCacheEntryEvictionTime(key) {
        this.clearCacheEntryEvictionTimeIfExists(key);
        this.setCacheEntryEvictionTime(key);
    }
    evictExpiredCacheEntries() {
        let cacheKey;
        // Not using this.cache.forEach so we can break the loop once
        // we find the fist non-expired entry. Each entry after that
        // is guaranteed to also be non-expired, because iteration happens
        // in insertion order
        for (cacheKey of this.cache.keys()) {
            if (!this.isCacheEntryValid(cacheKey)) {
                this.delete(cacheKey);
            }
            else {
                break;
            }
        }
    }
    entries() {
        this.evictExpiredCacheEntries();
        return super.entries();
    }
    keys() {
        this.evictExpiredCacheEntries();
        return super.keys();
    }
    values() {
        this.evictExpiredCacheEntries();
        return super.values();
    }
    delete(key) {
        this.clearCacheEntryEvictionTimeIfExists(key);
        return super.delete(key);
    }
    has(key) {
        if (!this.isCacheEntryValid(key)) {
            this.delete(key);
            return false;
        }
        return this.cache.has(key);
    }
    get(key) {
        if (!this.isCacheEntryValid(key)) {
            this.delete(key);
            return undefined;
        }
        const value = super.get(key);
        if (value !== undefined) {
            // Whenever we get a cache hit, we need to reset the timer
            // for eviction, because it is now considered most recently
            // accessed thus the timer should start over. Not doing that
            // will cause a de-sync that will stop proper eviction
            this.resetCacheEntryEvictionTime(key);
        }
        return value;
    }
    set(key, value) {
        const cache = super.set(key, value);
        this.resetCacheEntryEvictionTime(key);
        return cache;
    }
}
exports.TLRUCache = TLRUCache;
//# sourceMappingURL=tlru-cache.js.map